import React, { Component } from 'react';


class Job extends Component {

	constructor(props){

       super(props);

    }

		renderLine(){
			return (<span>&nbsp; | &nbsp;</span>);
		}

	render(){

		return (
			<div className="job">
				<div className="position">{this.props.position}</div>
				<div className="company">{this.props.company}</div>
				<div className="location">{this.props.time} {(this.props.location) ? this.renderLine() : ''}{this.props.location}</div>
				<a href={`https://${this.props.url}`} target="_blank">{this.props.url}</a>
			</div>
		);

	}

}


export default Job



// WEBPACK FOOTER //
// ./src/Components/Job.js